import { render, staticRenderFns } from "./ArticleCardAd.vue?vue&type=template&id=93fafef8&"
import script from "./ArticleCardAd.vue?vue&type=script&lang=js&"
export * from "./ArticleCardAd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports